<div class='link' (click)='goToRRD()'>
    <slot name="link_name">
      Link Name
    </slot>
</div>
